module.exports = __webpack_public_path__ + "img/icon-type-unUse.89e23808.png";